import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface DeleteModal {
  open: boolean;
  path: string;
  entityId?: string;
  closeDrawer?: boolean;
}
interface DeleteModalState {
  modal?: DeleteModal;
}

const initialState = {
  modal: undefined,
} satisfies DeleteModalState as DeleteModalState;

export const deleteModalSlice = createSlice({
  name: "deleteModal",
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<DeleteModal | undefined>) => {
      state.modal = action.payload;
    },
  },
});

export const selectDeleteModal = (state: RootState) => state.deleteModal.modal;
export const { setModal } = deleteModalSlice.actions;
export type RoleState = ReturnType<typeof deleteModalSlice.reducer>;
export default deleteModalSlice.reducer;
